<template lang="pug">
  div.marginTop(class="card-body")
    p Responda as perguntas abaixo para prosseguir:
    el-row
      el-col(:xl="8", :lg="12")
        div.question
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="O título a ser permutado pertence ao Projeto Integrado Trairão ?", :required="true")
            el-radio-group.radio-group(
              name="pertenceAoProjeto",
              v-model="cadastro.qualificacao.pertenceAoProjeto",
              @change="clearSelectedGleba"
              :class="{'erro' : errors[0]}"
            )
              el-radio.radio(:label='true') Sim
              el-radio.radio(:label='false') Não
            span.help.erro {{ errors[0] }}
    el-row
      el-col(:xl="8", :lg="10", :sm="12")
        div.question(v-if="cadastro.qualificacao.pertenceAoProjeto")
          validation-provider(rules="required", v-slot="{ errors }", name="Glebas")
            app-label(label="Informe a gleba de localização da área de interesse:", :required="true")
            el-select.input(
              class="select"
              placeholder="Selecione",
              v-model="cadastro.qualificacao.gleba",
              no-match-text="Nenhuma gleba encontrada",
              filterable,
              clearable,
              name="gleba",
              value-key="id",
              :class="{'erro' : errors.length}"
            )
              el-option(
                v-for="item in glebas"
                :key="item.id"
                :label="item.nome"
                :value="item"
              )
            span.help.erro {{ errors[0] }}
    el-row
      el-col(:lg="12", :sm="24")
        div.question
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="O interessado é o beneficiário original ?", :required="true")
            el-radio-group.radio-group(
              name="beneficiarioOriginal",
              v-model="cadastro.qualificacao.beneficiarioOriginal",
              :class="{'erro' : errors[0]}"
            )
              el-radio.radio(:label='true') Sim
              el-radio.radio(:label='false') Não
            span.help.erro {{ errors[0] }}
    el-row
      el-col(:lg="12", :sm="24")
        div.question
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="O Valor da Terra Nua (VTN) foi pago integralmente ?", :required="true")
            el-radio-group.radio-group(
              name="pagoIntegral",
              v-model="cadastro.qualificacao.pagoIntegral",
              :class="{'erro' : errors[0]}"
            )
              el-radio.radio(:label='true') Sim
              el-radio.radio(:label='false') Não
            span.help.erro {{ errors[0] }}
</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import AppLabel from '@/components/AppLabel'
import glebas from '@/constants/glebas'

export default {
  components: {
    AppTextEditor,
    AppLabel
  },

  props: ['cadastro'],

  data () {
    return {
      glebas
    }
  },

  methods: {
    clearSelectedGleba () {
      this.cadastro.qualificacao.gleba = null
    }

  }

}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.btns {
  margin-top: 2%;
}
.question {
  padding: 10px;
}
.card {
  width: 80%;
  margin-left: 10%;
  margin-top: 20px;
}
.card-body {
  padding: 20px;
}
.floatRight {
  float: right;
}
.radio {
  margin: 5px;
}
.marginTop {
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/Qualificacao.vue